<template>
  <div>
    <div class="mt-4 mx-2">
      <v-row class="">
        <v-col md="4">
          <div class="text-h5 ml-3 float-left" >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small @click="getData()" v-bind="attrs" fab class="neu-glow float-left mr-5" active-class="neu-glow-inset" v-on="on" :loading="loading">
                  <v-icon 
                    large
                    color="info"
                    class="mx-3"
                    active-class="neu-glow-inset"
                    >
                      mdi-sync-circle
                  </v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
            Recensioni: {{reviews?reviews.length:''}}
          </div>
        </v-col>
        <v-col cols="8" class="text-left">
          <!--
          <div class="float-left" v-if="reviews">
            <template v-for="(avg,avgi) in [{name:'Cibo',code:'avgFood'},{name:'Servizio',code:'avgService'},{name:'Q/P',code:'avgValue'},{name:'Location',code:'avgLocation'},{name:'Score',code:'avrg'}]">

              <v-tooltip top :key="avgi">
                <template v-slot:activator="{ on, attrs }">              
                  <v-progress-circular
                    v-bind="attrs"
                    v-on="on"                  
                    :rotate="270"
                    :size="50"
                    :width="5"
                    :value="(reviews[0][avg.code]-3)*50"
                    :color="reviews[0][avg.code]>=4.6?'success':(reviews[0][avg.code]>=4?'warning':'error')"
                    :class="avgi<4?'mr-10':'ml-16'"
                  >
                    {{reviews[0][avg.code]}}
                  </v-progress-circular>
                </template>
                <span> {{avg.name}}</span>
              </v-tooltip>                  
            </template>
          </div>
          -->
          <v-spacer></v-spacer>
          <div class="float-right">
            <v-btn class="mr-4" @click="dialog_range=true">Periodo {{rangeString}}</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="expired">
        <v-col>
          <v-alert
            class="float-left mb-0"
            v-if="expired.showAlert"
            text
            dense
            transition="scale-transition"
            type="error"
          >
            <v-row
              align="center"
              no-gutters
            >
              <v-col v-if="expired.expired" class="grow font-weight-bold">
                Modulo Scaduto il {{expired.expiry}}: Vai al carrello per riattivarlo
              </v-col>
              <v-col v-else class="font-weight-bold">
                Questo Modulo scade il {{expired.expiry}}: Vai al carrello per Estenderne la durata
              </v-col>
              <v-col class="shrink font-weight-bold pl-8">
                <v-btn
                  small
                  to='/shop'
                  color="info"                            
                >
                  Estendi
                </v-btn>
              </v-col>
            </v-row>                    
          </v-alert>  
        </v-col>
      </v-row>        
      <v-row class="d-flex justify-center px-6" v-if="reviews&&reviews.length">
        <v-col class="px-0" v-for="(avg,avgi) in [{name:'Cibo',code:'avgFood'},{name:'Servizio',code:'avgService'},{name:'Q/P',code:'avgValue'},{name:'Location',code:'avgLocation'},{name:'Punteggio',code:'avrg'}]" :key=avgi>
          <v-card class="neu-glow pa-4 mx-2">
            <v-row>
              <v-col cols="12" class="text-center">
                  <v-progress-circular
                    v-bind="attrs"
                    v-on="on"
                    :style="'height:'+wWidth/10+'px'"
                    :rotate="270"
                    :size="avgi==4?wWidth/10:wWidth/12"
                    :width="avgi==4?wWidth/80:wWidth/180"
                    :value="(reviews[0][avg.code]-3)*50"
                    :color="reviews[0][avg.code]>=4.7?'success':(reviews[0][avg.code]>=4.6?'warning':'error')"
                  >
                    {{reviews[0][avg.code]}}
                  </v-progress-circular>                
              </v-col>
              <v-col cols="12" class="text-h5 text-center">{{avg.name}}</v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>    
      <v-row>        
        <v-col cols="12">
          <v-card class="neu-glow mx-4">
            <v-tabs
              v-model="tab"
              align-with-title
            >
              <v-tabs-slider color="info"></v-tabs-slider>
    
              <v-tab
                v-for="item in tabs"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item
                key="0"
              >
                <v-card class="neu-glow ma-4 pa-4">                 
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Cerca:"
                        color="info"
                        single-line
                        hide-details
                        class="float-right mt-n2"
                        style="max-width:250px"
                      ></v-text-field>                      
                    </v-col>
                    <v-col cols="12">
                      <v-data-table
                        dense
                        fixed-header
                        :headers="headers"
                        :items="reviews||[]"
                        hide-default-footer
                        :items-per-page=500
                        :height="wHeight-285"
                        :loading="loading"
                        no-data-text="Nessun dato presente in archivio"
                        no-results-text="Nessun Risultato estratto"
                        loading-text="Consultazione archivio: attendi..."
                        single-expand
                        :expanded.sync="expanded"
                        item-key="bookingId"
                        show-expand
                        :search="search"        
                      >
                      <!--
                      <template slot="body.prepend">
                        <tr class="text-left">
                            <th class=" pl-4">Media</th>
                            <th><v-btn outlined small fab dense style="border-width:medium;border-color:red">150</th>
                            <th>260</th> 
                            <th>150</th>
                            <th>260</th>
                            <th>33%</th>
                        </tr>
                        </template>
                        -->

                        <template v-slot:[`item.food`]="{ item }">
                          <v-icon large :color="item.food>3?'success':(item.food==3?'warning':'error')">{{'mdi-numeric-'+item.food+''}}</v-icon>                           
                        </template>  
                        <template v-slot:[`item.service`]="{ item }">
                          <v-icon large :color="item.service>3?'success':(item.service==3?'warning':'error')">{{'mdi-numeric-'+item.service+''}}</v-icon>    
                        </template>  
                        <template v-slot:[`item.value`]="{ item }">
                          <v-icon large :color="item.value>3?'success':(item.value==3?'warning':'error')">{{'mdi-numeric-'+item.value+''}}</v-icon>    
                        </template>
                        <template v-slot:[`item.location`]="{ item }">
                          <v-icon large :color="item.location>3?'success':(item.location==3?'warning':'error')">{{'mdi-numeric-'+item.location+''}}</v-icon>    
                        </template>    

                        <template v-slot:[`item.score`]="{ item }">
                          <!--<div class="text-h6">{{(item.score/4).toFixed(1)}}</div>-->
                          <v-icon class="mr-n3" large :color="(item.score/4)==5?'accent':(item.score/4)>=4?'success':((item.score/4)>=3?'warning':'error')">{{'mdi-numeric-'+(item.score/4).toFixed(1).split('.')[0]+''}}</v-icon>
                          .
                          <v-icon class="ml-n3" large :color="(item.score/4)==5?'accent':(item.score/4)>=4?'success':((item.score/4)>=3?'warning':'error')">{{'mdi-numeric-'+(item.score/4).toFixed(1).split('.')[1]+''}}</v-icon>   
                        </template>  

                        <template v-slot:[`item.date`]="{ item }">
                          <div v-html="item.date+ '<br />'+item.time"></div>
                        </template>

                        <template v-slot:[`item.clickedTime`]="{ item }">
                          <!--
                          <v-tooltip top :disabled="item.clickedTime">
                            <template v-slot:activator="{ on, attrs }">
                              clickedChannel

                              <v-simple-checkbox
                                v-bind="attrs" 
                                v-on="on"
                                :value="item.clickedTime?1:0"
                              >
                              </v-simple-checkbox>
                            </template>
                            <span>{{item.clickedTime}}</span>
                          </v-tooltip>-->

                          <v-tooltip top :disabled="!item.clickedTime">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs" 
                                  v-on="on"                                
                                  color="green darken-2"
                                >
                                  {{!item.clickedChannel?'':item.clickedChannel=='ta'?'fab fa-tripadvisor':'mdi-google'}}
                                </v-icon>                
                            </template>
                            <span>{{item.clickedTime}}</span>
                          </v-tooltip>

                        </template>                    

                        <template v-slot:[`item.tripadvisorReviewId`]="{ item }">
                          <v-tooltip top v-if="item.tripadvisorReviewId">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="info"
                                  class="mr-2"
                                >
                                  fab fa-tripadvisor
                                </v-icon>                
                            </template>
                            <span>TA</span>
                          </v-tooltip>
                          <v-tooltip top v-if="item.googleReviewId">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  style="cursor:pointer"
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="info"
                                  class="mr-2"
                                >
                                  mdi-google
                                </v-icon>                
                            </template>
                            <span>Google</span>
                          </v-tooltip>                      
                        </template>                    

                        <template v-slot:[`item.phone`]="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" :href="'tel:'+item.countryCode+item.phone">
                                <v-icon
                                  color="green"
                                >
                                  mdi-phone
                                </v-icon>                
                              </v-btn>
                            </template>
                            <span>Chiama</span>
                          </v-tooltip>
                        </template>

                        <template v-slot:[`item.wa`]="{ item }">
                          <!--
                          <v-tooltip top v-if="item.reviewPrize">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs" 
                                  v-on="on"
                                  large
                                  color="warning"
                                  @click="editTicket(item)"
                                >
                                  mdi-ticket
                                </v-icon>                
                            </template>
                            <span>Modifica Coupon</span>
                          </v-tooltip>
                          -->

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs" 
                                  v-on="on"
                                  color="success"
                                  class="ml-4"
                                  @click="open_dialog_sendWA(item)"
                                >
                                  mdi-whatsapp
                                </v-icon>                
                            </template>
                            <span>Messaggio WA</span>
                          </v-tooltip>                      
                        </template>
                        <template v-slot:[`item.coupon`]="{ item }">
                          <!--
                          <v-tooltip top v-if="item.reviewPrize">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs" 
                                  v-on="on"
                                  large
                                  color="warning"
                                  @click="editTicket(item)"
                                >
                                  mdi-ticket
                                </v-icon>                
                            </template>
                            <span>Modifica Coupon</span>
                          </v-tooltip>
                          -->



                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs" 
                                  v-on="on"
                                  :color="item.couponId?'warning':'info'"
                                  class="ml-4"
                                  @click="editTicket(item)"
                                >
                                  mdi-ticket
                                </v-icon>                
                            </template>
                            <span>{{item.couponIssued?'Inviato il '+item.couponIssued:'Invia Coupon'}}</span>
                          </v-tooltip>                      
                        </template>

                        <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
                          <v-btn icon @click="expand(true)" v-if="item.review && !isExpanded"><v-icon>mdi-chevron-down</v-icon></v-btn>
                          <v-btn icon @click="expand(false)" v-if="item.review && isExpanded"><v-icon>mdi-chevron-up</v-icon></v-btn>
                        </template>

                        <template v-slot:expanded-item="{ item }">
                          <td :colspan="headers.length/1+1/1" class="px-4 py-3 text-subtitle-1 blue-grey darken-2">
                            {{ item.review }}
                          </td>
                        </template>

                      </v-data-table>
                    </v-col>                
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item
                key="1"
              >
                <v-card v-if="reviewsTA" class="neu-glow ma-4 pa-4">
                  <v-row dense>
                    <v-col cols="12">
                      <v-data-table
                        dense
                        fixed-header
                        :headers="headersTA"
                        :items="reviewsTA||[]"
                        hide-default-footer
                        :items-per-page=500
                        :height="wHeight-235"
                        :loading="loading"
                        no-data-text="Nessun dato presente in archivio"
                        no-results-text="Nessun Risultato estratto"
                        loading-text="Consultazione archivio: attendi..."
                        single-expand
                        :expanded.sync="expandedTA"
                        item-key="reviewId"
                        show-expand             
                      >
                        <template v-slot:expanded-item="{ item }">
                          <td :colspan="headersTA.length+1" class="px-4 py-3 text-subtitle-1 info blue-grey darken-3">
                            {{ item.review }}
                          </td>
                        </template>
                      </v-data-table>
                    </v-col>                
                  </v-row>
                </v-card>
              </v-tab-item> 
              <v-tab-item
                key="2"
              >
                <v-card v-if="reviewsG" class="neu-glow ma-4 pa-4">
                  <v-row dense>
                    <v-col cols="12">
                      <v-data-table
                        dense
                        fixed-header
                        :headers="headersG"
                        :items="reviewsG||[]"
                        hide-default-footer
                        :items-per-page=500
                        :height="wHeight-235"
                        :loading="loading"
                        no-data-text="Nessun dato presente in archivio"
                        no-results-text="Nessun Risultato estratto"
                        loading-text="Consultazione archivio: attendi..."
                        single-expand
                        :expanded.sync="expandedG"
                        item-key="reviewId"
                        show-expand
                        :search="searchG"               
                      >
                      <template v-slot:top>
                        <v-text-field
                          v-model="searchG"
                          label="Cerca"
                          class="mx-4"
                        ></v-text-field>
                      </template>

                      <!--
                        <template v-slot:[`item.callerId`]="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <a :href="'tel:+'+item.callerId" style="text-decoration:none;" class="pt-2 pl-2">
                                <span class="mr-2">{{item.callerId}}</span>
                                <v-icon @click="markSeen(item)" :class="item.called?'grey--text':(item.hasBooking?'success--text':(item.menu=='13'?'error--text':'warning--text'))" v-bind="attrs" v-on="on">mdi-phone</v-icon>
                              </a>
                            </template>
                            <span>{{item.hasBooking?'prenotato':item.called?'Chiamata '+item.called:(item.menu=='13'?'Attende Chiamata':'Chiama')}}</span>
                          </v-tooltip>
                        </template>

                        <template v-slot:[`item.active`]="{ item }">
                          <v-simple-checkbox
                            v-bind="attrs" v-on="on"
                            v-model="item.active"
                            color="success"
                          ></v-simple-checkbox>
                        </template>
                      -->
                    

                        <template v-slot:expanded-item="{ headersTA, item }">
                          <td :colspan="headersTA.length+1" class="px-4 py-3 text-subtitle-1 info lighten-4">
                            {{ item.review }}
                          </td>
                        </template>
                      </v-data-table>
                    </v-col>                
                  </v-row>
                </v-card>
              </v-tab-item>                            
            </v-tabs-items>
          </v-card>
        </v-col> 
      </v-row>
    </div>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3"
            >
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
                <v-col md="6" cols="12">
                    <p>Il campo <strong>Coupon Omaggio</strong>' è un campo libero, visibile al cliente che contiene la descrizione dell'oggetto del Coupon: es: "Buono per 1 pizza"</p>
                    <p>Il campo <strong>Note Interne Coupon</strong>, invece, è visibile solamente allo Staff</p>
                    <p>Il campo <strong>Coupon Valido fino Al</strong>, definisce la scadenza del Coupon: oltre tale data non sarà utilizzabile</p>
                </v-col>
                <v-col md="6" cols="12">
                  <p>Il pulsante <strong>Non Usato/Usato</strong>, indica se il coupon è stato "già speso" o meno, ma, impostandolo ad "usato" equivale a cancellarlo,
                   mentre impostando su "non Usato" un coupon già utilizzato, lo si rende nuovamente utilizzabile</p>
                  <p>
                    Nel campo <strong>Non valido nei giorni</strong> vanno indicati i giorni in cui non è valido considerando 1 = lunedì fin a 7 = Domenica
                    <br /> ad esempio, 267 significa che il coupon non è utilizzabile Martedì, Sabato e Domenica.
                  </p>
                  <p>Con Il campo <strong>Messaggio</strong>, contiene il messaggio allegato al coupon, che nel caso si scelga l'invio, verrà inserito nel messaggio WhatsApp inviato al cliente</p>
                  <p>Relativamente ai pulsanti, è possibile Inviare un messaggio WhatsApp <v-icon color="error">mdi-whatsapp</v-icon> o semplicemente salvare il coupon creato/modificato <v-icon color="error">mdi-content-save</v-icon> </p>
                </v-col>
                <!--
                <v-col cols="12">
                    <p class="error--text">
                        <strong><sup>1</sup></strong>
                    </p>
                </v-col>
                -->
            </v-row>
        </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_edit" max-width="1200" class="pb-3" v-if="editedItem">
      <v-card class="neu-glow">
          <v-card-title class="text-h5 mb-1">
            Invia Coupon a {{editedItem.fullName}}
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-4" :loading="loading_sendCoupon" @click="saveItem('send')">
                    <v-icon color="error">mdi-whatsapp</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Invia</span>
            </v-tooltip>
            <v-tooltip top >
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="dialog_edit=false" fab small class="neu-glow mr-4" v-bind="attrs" v-on="on">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <v-btn to="/settings/?pageId=coupons" v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-4">
                    <v-icon color="error">mdi-creation</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Crea Nuovo Coupon</span>
            </v-tooltip>            
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                              
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-2 mb-0 pb-3">
            <v-col cols="9">
              <v-card-text>
                <div class="mb-2">Scegli Coupon</div>
                <v-data-table
                  v-model="selectedCoupon"
                  class="neu-glow"
                  item-key="prizeId"
                  fixed-header
                  show-select
                  single-select="true"
                  :headers="headersCoupons"
                  :items="prizes||[]"
                  hide-default-footer
                  :items-per-page=500
                  :loading="loading||loading_refresh"
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."
                >

                  <template v-slot:[`item.validDoW`]="{ item }">
                    <div>
                      <!--
                      <v-btn-toggle v-model="item.validDoW" multiple small active-class="info" class="d-inline-block transparent">
                        <v-btn
                          style="pointer-events: none"
                          x-small
                          v-for="(d,di) in dows" :key="di" :value="d.code">
                          {{d['it'].substring(0,2).toUpperCase()}}
                        </v-btn>
                      </v-btn-toggle> 
                    -->
                    <span v-for="(d,di) in dows.filter(d => item.validDoW.includes(d.code))" :key="di">
                      {{d['it'].substring(0,2).toUpperCase()}}
                    </span>                     
                    </div>
                  </template>

                  <template v-slot:[`item.highRewardRange`]="{ item }">
                    <div>{{item.highRewardRange.join('-')}}</div>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    
                    <!--
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="showItem(item)">
                          <v-icon
                            v-bind="attrs" 
                            v-on="on"
                            color="info"
                            class="mr-2"
                          >
                            mdi-check-circle
                          </v-icon> 
                        </v-btn>               
                      </template>
                      <span>Visualizza</span>
                    </v-tooltip>
                    -->

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">

                        <v-simple-checkbox
                          v-bind="attrs" 
                          v-on="on"
                          v-model="item.selected"
                          @click="showItem(item)"
                        >
                        </v-simple-checkbox>
                      </template>
                      <span></span>
                    </v-tooltip>                    

                  </template>

                </v-data-table>
              </v-card-text>                

              <v-row v-if="selectedCoupon" class="mt-2 mx-2">                                           
                <v-col cols="12" md="6">
                  <v-img v-if="selectedCoupon[0].highRewardImage" 
                    :src="'/static/users/pictures/coupons/'+selectedCoupon[0].highRewardImage||'/static/users/pictures/coupons/default.png'"
                    :lazy-src="'/static/users/pictures/coupons/'+selectedCoupon[0].highRewardImage||'/static/users/pictures/coupons/default.png'"
                    max-width="200"
                    class="mx-auto"
                  ></v-img>              
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    class="mt-4"            
                    counter
                    rows="7"
                    auto-grow
                    label="Messaggio Coupon"
                    outlined
                    v-model="editedItem.highRewardDescription"
                  >
                  </v-textarea>                          
                </v-col>                                                                                                                       
              </v-row>
            </v-col>
            <v-col cols="3" v-if="editedItem">
              <div class="my-3">Messaggio Whatsapp:</div>
              <v-card class="pa-4  neu-glow">
                <v-row class="">   
                  <v-col cols="12" md="12">
                    <v-img 
                      :src="'/static/users/pictures/wa/'+editedItem.logoWA"
                      :lazy-src="'/static/users/pictures/wa/'+editedItem.logoWA"
                      max-width="250"
                      class="mx-auto"
                    ></v-img>              
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-card class="pa-4 neu-glow">
                      <div>
                        <p>
                          {{$t('Review.Dear') + ' ' +  editedItem.fullName}},
                        </p>
                        <p>
                          <span v-html="shownMSG"></span>
                        </p>
                        <p>
                          Clicca sul pulsante in fondo per visualizzare il coupon
                        </p>
                        <p>
                          Lo Staff
                          <br>{{editedItem.brand}}
                        </p>
                      </div>
                      <div>
                        <v-btn
                          outlined
                          block
                          color="info"
                        >
                          Visualizza Coupon
                        </v-btn>
                      </div>
                    </v-card> 
                  </v-col>  
                </v-row>
              </v-card>
            </v-col>
          </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_sendWA" max-width="500" class="pb-3" v-if="editedItem">
        <v-card class="neu-glow">
            <v-card-title class="text-h5 mb-1">
              Invia Messaggio
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2" :disabled="!editedItem.freeMessage" :loading="loading_sendWA" @click="sendWA()">
                      <v-icon color="success">mdi-whatsapp</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Invia</span>
              </v-tooltip>
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialog_sendWA=false;editedItem.freeMessage=freeMessage" fab small class="neu-glow mr-2"  v-bind="attrs" v-on="on">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>               
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="editedItem.freeMessage=''" fab small class="neu-glow mr-2"  v-bind="attrs" v-on="on">
                    <v-icon color="info">mdi-spray-bottle</v-icon>
                  </v-btn>
                </template>
                <span>Pulisci</span>
              </v-tooltip>              
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-3 mb-0 pb-3">
              <v-col cols="12">
                <v-card class="neu-glow pa-4">
                  <v-textarea            
                    counter
                    min="1"
                    max="31"
                    dense
                    label="Messaggio"
                    outlined
                    class="pa-3"
                    v-model="editedItem.freeMessage"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-textarea>
                </v-card> 
              </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_range"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Scegli Periodo
          <v-spacer></v-spacer>             
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_range=false;getData()">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4">
          <v-date-picker
            v-model="dateRange"
            scrollable
            range
            color="info"
            show-adjacent-months
            full-width
            :first-day-of-week="1"
            locale="it"
            show-week
          >
          </v-date-picker>
        </v-card>
      </v-card>
    </v-dialog>     
    <v-snackbar v-model="snackbar.active"
      top
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.message}}
    </v-snackbar>          
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      page: "Reviews",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      loading_sendWA:false,
      loading_sendCoupon:false,
      dialog_edit:false,
      dialog_instruction:false,
      dialog_sendWA:false,
      dialog_range:false,
      snackbar:{active:false,color:'success',message:''},
      reviews:null,
      reviewsTA:null,
      reviewsG:null,
      loading:false,
      expanded:false,
      expandedTA:false,
      expandedG:false,
      search:null,
      searchTA:null,
      searchG:null,
      tab:null,
      shownMsg:'',
      tabs:["Interne","TripAdvisor"],
      prizes:null,
      selectedCoupon:null,
      menuDatePicker:false,
      expired:null,
      search:null,
      dateRange:[new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),new Date().toISOString().substring(0, 10)],
      defaultMessage:'Ti ringraziamo per la tua recensione: ci aiuta a migliorarci. Ti abbiamo riservato un coupon omaggio da spendere nei prossimi giorni',
      editedItem:{bookingId:null,reviewPrize:null,reviewPrizeValidUntil:null,prizeSpent:null,active:false,message:null,freeMessage:'Grazie per la sua Recensione da tutto lo staff',highRewardDescription:'Ti ringraziamo per la tua recensione: ci aiuta a migliorarci.Ti abbiamo riservato un coupon omaggio da spendere nei prossimi giorni'},
      emptyItem: {bookingId:null,reviewPrize:null,reviewPrizeValidUntil:null,prizeSpent:null,active:false,message:null},
      freeMessage:'Grazie per la sua Recensione da tutto lo staff',
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],      
      headers: [
                { text: 'Giorno',       value: 'date',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                //{ text: 'Ora',          value: 'time',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Name',         value: 'fullName',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Cibo',         value: 'food',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Serv',         value: 'service',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Q/P',          value: 'value',       align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Location',     value: 'location',    align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Score',        value: 'score',       align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                //{ text: 'Recensione',   value: 'review',    align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Click TA',     value: 'clickedTime', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                //{ text: 'Recensioni',   value: 'tripadvisorReviewId',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Chiama',       value: 'phone',       align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },

                { text: 'Invia WA',     value: 'wa',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Invia Coupon', value: 'coupon',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ], 
      headersTA: [
                { text: 'Giorno',       value: 'travelDate',  align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Name',         value: 'username',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'City',         value: 'userLocation', align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Score',        value: 'rating',      align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Title',        value: 'title',       align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Tipo',         value: 'tripType',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'C.Utili',      value: 'helpfulVotes', align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Cibo',         value: 'food',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Serv',         value: 'service',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Q/P',          value: 'value',       align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ],  
      headersG: [
                { text: 'Giorno',       value: 'travelDate',  align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Name',         value: 'username',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'City',         value: 'userLocation', align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Score',        value: 'rating',      align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Title',        value: 'title',       align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Tipo',         value: 'tripType',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'C.Utili',      value: 'helpfulVotes', align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Cibo',         value: 'food',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Serv',         value: 'service',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Q/P',          value: 'value',       align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ],
      headersCoupons: [
          { text: 'Titolo',         value: 'prizeName',   align: 'start',   sortable: false, class:'px-1 text-lg-button' },
          { text: 'Durata gg',      value: 'duration',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          { text: 'Giorni Validi',  value: 'validDoW',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          //{ text: 'Range',   value: 'highRewardRange',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          //{ text: 'Scegli',         value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          { text: 'Scegli',         value: 'data-table-select',align: 'center',  sortable: false, class:'pl-1 text-lg-button' }
        ],                                                  
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    rangeString: function()
    {
      console.log(260,this.dateRange)
      const options={ year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(this.dateRange[0]).toLocaleDateString('it', options) + ' - ' + new Date(this.dateRange[1]).toLocaleDateString('it', options)
    }  
  },
  created(){
    
    this.getData()
  },
  watch:
  {
    'editedItem.highRewardDescription': function (newVal,oldVal)
    {
      //this.editedItem.highRewardDescription='Ti ringraziamo per la tua recensione: ci aiuta a migliorarci.\nTi abbiamo riservato un coupon omaggio da spendere nei prossimi giorni'

      this.shownMSG=newVal?newVal.replace(/\n/g,''):'';
      if (newVal.includes("\n"))
      {
        this.snackbar.message='Il carattere "a capo" non può essere inserito nel messaggio whatsapp';
        this.snackbar.color='warning';
        this.snackbar.active=true;
      }
      console.log(386,this.editedItem,newVal,oldVal)
    },
    selectedCoupon(newVal,oldVal)
    {
      //console.log(809,newVal[0],oldVal[0])
      //if(!oldVal[0]||newVal[0]!=oldVal[0])
      {
        this.editedItem.highRewardDescription='Ti ringraziamo per la tua recensione: ci aiuta a migliorarci.\nTi abbiamo riservato un coupon omaggio da spendere nei prossimi giorni'
      }
    },
    /*
    dateRange(newValue,oldValue)
    {
      console.log(293,newValue,oldValue)
      if(newValue!=oldValue)
      {
        this.getData()
      }
    }   */ 
  },
  methods:
  {
    /*showItem(i)
    {
      console.log(719,i)
      this.selectedCoupon=i;
      console.log(726,this.selectedCoupon);
    },
    */
    open_dialog_sendWA(item)
    {
      this.dialog_sendWA=true;
      this.editedItem.bookingId=item.bookingId;

    },
    editTicket(f)
    {
      if (f) 
      {
        this.editedItem=f;
      }
      else{
        this.editedItem={...this.emptyItem};
        this.editedItem.active=1;
      }
      console.log(757,f)
      //this.editedItem.highRewardDescription='Ti ringraziamo per la tua recensione: ci aiuta a migliorarci.\nTi abbiamo riservato un coupon omaggio da spendere nei prossimi giorni';
      this.hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteTicket(f)
    {
      this.editedItem=f;
      console.log(765,f)
      this.dialog_delete=true;
    },    
    async sendWA(a)
    {
        console.log(144,this.editedItem);
        this.loading_sendWA=true;
        console.log(255,this.form);

        let editedItem= (({ bookingId, freeMessage }) => 
          ({ bookingId, freeMessage }))(this.editedItem);
        //ed.prizeSpent=ed.prizeSpent==''?null:ed.prizeSpent;
        
        let payload={"action":"sendWA","payload":editedItem};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_sendWA=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar.color="success"
            this.snackbar.message =w.message;
            this.snackbar.active = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.dialog_sendWA=false;
            //this.hash=JSON.stringify(this.editedItem);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        //this.editedItem={...this.emptyItem}
    }, 
    async saveItem(a)
    {
        console.log(144,this.editedItem, this.selectedCoupon[0]);
        this.loading_sendCoupon=true;

        let editedItem= (({ bookingId, highRewardDescription }) => 
          ({ bookingId, highRewardDescription }))(this.editedItem);
        //ed.prizeSpent=ed.prizeSpent==''?null:ed.prizeSpent;
        editedItem.prizeId=this.selectedCoupon[0].prizeId;
        let payload={"action":"couponSend","table":"Reviews","payload":editedItem};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_sendCoupon=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar.color="success"
            this.snackbar.message =w.message;
            this.snackbar.active = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.hash=JSON.stringify(this.editedItem);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }
        else{
            this.snackbar.color="error";
            this.snackbar.message =w.message;
            this.snackbar.active = true;
        }   
        //this.editedItem={...this.emptyItem}
    },    
    async getData()
    {
        {
            this.loading=true;
            //try{
                const payload=JSON.stringify({"dateRange": this.dateRange,"action":"Reviews_get"});
                const res = await this.$http.post('/review/review.php', payload );
                console.log(126,res);
                this.loading= false;
                switch (res.data.errorid)
                {
                  case '0':
                      console.log(761,this.settings)
                      //document.title = this.settings.username+' | '+this.page;
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.reviews=res.data.payloads.reviews?res.data.payloads.reviews:[];
                      this.reviewsTA=res.data.payloads.reviewsTA?res.data.payloads.reviewsTA:[];
                      this.reviewsG=res.data.payloads.reviewsG?res.data.payloads.reviewsG:[];
                      this.prizes=res.data.payloads.allPrizes;
                      this.expired=res.data.payloads.expired;
                      console.log(132,this.reviews,this.prizes);
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            /*} catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }*/
        }
    },
    async markSeen (item)
    {
        let payload={"action":"Reviews_Seen_set","payload":JSON.stringify(item)};
        console.log(113,payload)
        const idx=this.reviews.findIndex(m =>m.callId==item.callId)
        console.log(119,idx)
        this.reviews[idx].called=new Date;
        let w= await this.updateDB(payload)
        console.log(122,w);       
        this.snackbar=false;
        if (w.errorid=='0')
        {
            //console.log(126,w.payloads.callId)
            //const idx=this.reviews.findIndex(m =>m.callId==w.payloads.callId)
            //console.log(128,idx)
            //this.reviews[idx].called=new Date;
            //console.log(130,this.reviews)
        }	
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/review/review.php', payload);
            console.log(127,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              if (res.data.payloads)
              {
                  console.log(133);
                  //this.snackbar=true;
              }
            }
            else
            {
              console.log(139);
              //this.$router.push('/auth/login').catch(() => {});
            }
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },    
  },
};
</script>
<style scoped>
.v-data-table__mobile-row{
  min-height: 24px!important;
}
</style>